/** Wire protocol version. Bump when envelope shape breaks compatibility. */
export const PROTOCOL_VERSION = 1 as const;

export type ProtocolVersion = typeof PROTOCOL_VERSION;

/**
 * Low-level channel object injected by Android WebView (WebMessageListener).
 * Not the same as `window.InnoSdk` (the high-level bridge API).
 *
 * Android: WebViewCompat.addWebMessageListener(..., "innoSdkChannel", ...)
 */
export const SDK_CHANNEL_OBJECT = "innoSdkChannel" as const;

/**
 * Optional hint the wrapper may set before page scripts run:
 * `window.__INNO_SDK__ = { wrapper: "webview" | "twa", version: "1.0.0" }`
 */
export const SDK_GLOBAL_HINT = "__INNO_SDK__" as const;
